import { Register } from './Register';

export function RegisterInvitation() {
  return <Register invite />;
}
